import { render } from "./CartFile.vue?vue&type=template&id=4fbc9ef9&scoped=true"
import script from "./CartFile.vue?vue&type=script&lang=ts"
export * from "./CartFile.vue?vue&type=script&lang=ts"

import "./CartFile.vue?vue&type=style&index=0&id=4fbc9ef9&lang=scss"
import "./CartFile.vue?vue&type=style&index=1&id=4fbc9ef9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fbc9ef9"

export default script